export interface OrderParams {
  storeName: string
  storePhone: string // 502XXXXXXXX
  buyerName: string
  buyerPhone?: string
  buyerAddress?: string
  items: Array<{ name: string; qty: number; price: number }>
  subtotal: number
  notes?: string
}

export function buildWhatsAppMessage(params: OrderParams): { message: string; url: string } {
  const { storeName, storePhone, buyerName, buyerPhone, buyerAddress, items, subtotal, notes } = params

  const lines: string[] = []
  lines.push('🔧 *Pedido FerreMarket*')
  lines.push(`Ferretería: ${storeName}`)
  lines.push('')
  lines.push(`👤 *Comprador:* ${buyerName}`)
  if (buyerPhone) lines.push(`📱 ${buyerPhone}`)
  if (buyerAddress) lines.push(`📍 *Dirección:* ${buyerAddress}`)
  lines.push('')
  lines.push('*Productos:*')
  for (const item of items) {
    lines.push(`• ${item.qty}x ${item.name} — Q ${item.price.toFixed(2)} c/u`)
  }
  lines.push('─────────────────')
  lines.push(`*Subtotal: Q ${subtotal.toFixed(2)}*`)
  if (notes) {
    lines.push('')
    lines.push(notes)
  }
  lines.push('')
  lines.push('Pedido generado en FerreMarket Guatemala')

  let message = lines.join('\n')

  const MAX_CHARS = 3000
  if (message.length > MAX_CHARS) {
    const truncated = message.slice(0, MAX_CHARS - 50)
    const lastNewline = truncated.lastIndexOf('\n')
    message = truncated.slice(0, lastNewline) + '\n...\nVer detalle completo en FerreMarket'
  }

  const url = `https://wa.me/${storePhone}?text=${encodeURIComponent(message)}`

  return { message, url }
}
